/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum Shared_AssetKinds {
    Text = 10,
    Document = 20,
    Link = 30,
}
